import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListBadges from './list-badges';
import BadgeDetail from './badge-detail';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const BadgeRoutes = () => (
  <>
    <Header />
    <Sidebar />
    <div className="page-wrapper">
      <div className="content">
        <Routes>
          <Route path="/list-badges" element={<ListBadges />} />
          <Route path="/badge-detail/:id" element={<BadgeDetail />} />
          <Route path="/" element={<ListBadges />} />
        </Routes>
      </div>
    </div>
  </>
);

export default BadgeRoutes; 